import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {IhsmDropdownLibComponent} from './ihsm-dropdown-lib.component';
import {NgbTooltipModule} from '@ng-bootstrap/ng-bootstrap';
import {FormsModule} from "@angular/forms";

@NgModule({
  declarations: [IhsmDropdownLibComponent],
    imports: [
        BrowserModule,
        NgbTooltipModule,
        FormsModule
    ],
  exports: [IhsmDropdownLibComponent]
})
export class IhsmDropdownLibModule {
}
